import { render } from "./DescriptionMat.vue?vue&type=template&id=ee83ab8e"
import script from "./DescriptionMat.vue?vue&type=script&lang=js"
export * from "./DescriptionMat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__